import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { APIURL } from '../../redux/action/config';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const UserCustomerProfile = () => {

    const [user, setUser] = useState()
    const [loading, setLoading] = useState(false)
    const [deactivating, setDeactivating] = useState(false)

    const cancelBtnRef = useRef(null);
    const navigate = useNavigate()

    const token = localStorage.getItem("customer_token")
    const customer_id = localStorage.getItem("customer_id");

    useEffect(() => {
        if (!customer_id && !token) {
            navigate('/customer-login')
        }
    }, [user])

    useEffect(() => {
        setLoading(true)
        if (customer_id) {
            axios.get(`${APIURL}/api/v1/users/${customer_id}`, {
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `token ${token}`
                }
            },)
                .then(response => {
                    if (response.status === 200) {
                        setUser(response?.data?.data?.user);
                    }
                })
                .catch(error => {
                    toast.error(error?.response?.data?.message)
                }).finally(() =>
                    setLoading(false)
                );
        }
    }, [])

    const handleDeactivate = async () => {
        try {
            if (!customer_id) return;
            setDeactivating(true);
            const response = await axios.patch(`${APIURL}/api/v1/users/deleteUsers/${customer_id}`, {
                isDeleted: true,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                toast.success(response?.data?.data?.message)
                localStorage.removeItem('token');
                localStorage.removeItem('userId');
                navigate('/customer-login')
                if (cancelBtnRef.current) {
                    cancelBtnRef.current.click();
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setDeactivating(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="container mt-5">
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <h2 className='text-center'>User Details</h2>
                        {loading ?
                            <div className='w-100 d-flex align-items-center justify-content-center min-h-200px'>
                                <div className="spinner-border text-danger" role="status" />
                            </div>
                            :
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <strong style={{ display: 'inline-block', width: '150px' }}>First Name</strong><strong>:{" "}</strong>{user?.firstName}
                                </li>
                                <li className="list-group-item">
                                    <strong style={{ display: 'inline-block', width: '150px' }}>Middle Name</strong><strong>:{" "}</strong>{user?.middleName}
                                </li>
                                <li className="list-group-item">
                                    <strong style={{ display: 'inline-block', width: '150px' }}>Last Name</strong><strong>:{" "}</strong>{user?.lastName}
                                </li>
                                <li className="list-group-item">
                                    <strong style={{ display: 'inline-block', width: '150px' }}>Email</strong><strong>:{" "}</strong>{user?.email}
                                </li>
                                <li className="list-group-item">
                                    <strong style={{ display: 'inline-block', width: '150px' }}>Phone</strong><strong>:{" "}</strong>{user?.phone}
                                </li>
                                <li className="list-group-item">
                                    <strong style={{ display: 'inline-block', width: '150px' }}>Position</strong><strong>:{" "}</strong>{user?.position}
                                </li>
                            </ul>}
                    </div>
                </div>
                {!loading && <div className='d-flex justify-content-center mt-4'>
                    <button type="button" className="btn btn-primary px-3 py-1" style={{ borderRadius: "4px" }} data-bs-toggle="modal" data-bs-target="#deactivate-modal">Deactive account</button>
                </div>}
            </div>
            <div className="modal fade" id="deactivate-modal" tabIndex="-1" aria-labelledby="deactivate-modal-label" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deactivate-modal-label">Deactivate account</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to deactivate your account?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary px-3 py-1" data-bs-dismiss="modal" style={{ borderRadius: "4px" }} ref={cancelBtnRef}>Cancel</button>
                            <button type="button" className="btn btn-primary px-3 py-1" style={{ borderRadius: "4px" }} onClick={handleDeactivate}>
                                {deactivating ? <div className="spinner-border spinner-border-sm text-white" role="status" /> : "Sure"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default UserCustomerProfile